import { coreSonarObjectsOptimisticChangeAddSlice } from './add';
import { coreSonarObjectsOptimisticChangeRemoveSlice } from './remove';

export const addSonarObjectsOptimisticChange = coreSonarObjectsOptimisticChangeAddSlice.syncActionCreator;
export const removeSonarObjectsOptimisticChange = coreSonarObjectsOptimisticChangeRemoveSlice.syncActionCreator;
